import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/main'
import Login from '@/view/login/login'
import ResetPassword from '@/view/resetPassword/resetPassword'
import uploadIntelligence from '@/view/uploadIntelligence/index.vue'
import SharePage from '@/view/sharePage/shareList'
import wxShare from '@/view/sharePage/wxShare'
import wxSuccess from '@/view/sharePage/success'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/404',
      name: '404页面',
      component: Main,
      children: [
        {
          path: '/404',
          name: '页面找不到啦~',
          component: () => import('@/view/errorPage/404'),
          meta: {
            name: '页面丢失'
          }
        }
      ]
    },
    {
      path: '/500',
      name: '500页面',
      component: Main,
      children: [
        {
          path: '/500',
          name: '页面出错啦~',
          component: () => import('@/view/errorPage/500'),
          meta: {
            name: '页面出错'
          }
        }
      ]
    },
    {
      path: '/uploadIntelligence',
      name: '上传情报',
      component: uploadIntelligence
    },
    {
      path: '/wxShare',
      name: '微信和解协议',
      component: wxShare
    },
    {
      path: '/wxSuccess',
      name: '微信和解成功',
      component: wxSuccess
    },
    {
      path: '/',
      redirect: '/home',
      component: Main,
      children: [
        {
          path: '/home',
          name: '工作台',
          component: () => import('@/components/home/home.vue'),
          meta: {
            type: '菜单',
            name: 'WorkBench',
            nameCode: 'WorkBench'
          }
        },
        {
          path: '/waitting',
          name: '待开发',
          component: () => import('@/view/waitting/waitting.vue')
        }
      ]
    },
    {
      path: '/',
      redirect: '/channel',
      component: Main,
      children: [
        {
          path: '/channel',
          name: '渠道商',
          component: () => import('@/components/channel/channel.vue'),
          meta: {
            type: '菜单',
            name: 'Channel',
            nameCode: 'Channel'
          }
        }
      ]
    },
    {
      path: '/',
      name: '个人中心',
      component: Main,
      children: [
        {
          path: '/personalCenter/information',
          name: '个人信息',
          component: () => import('@/view/personalCenter/information.vue'),
          meta: {
            type: '菜单',
            name: 'PersonalCenter',
            nameCode: 'PersonalCenter'
          }
        }
      ]
    },
    {
      path: '/',
      name: '成员管理',
      component: Main,
      children: [
        {
          path: '/setting/memberManage',
          name: '成员管理',
          component: () => import('@/view/setting/memberManage.vue'),
          meta: {
            type: '菜单',
            name: 'MemberManage',
            nameCode: 'MemberManage'
          }
        }
      ]
    },

    {
      path: '/',
      name: '分享页面',
      component: SharePage,
      children: [
        {
          path: '/shareList',
          name: '分享线索',
          component: () => import('@/view/sharePage/shareList.vue'),
          meta: {
            type: '菜单',
            name: '分享线索'
          }
        }
      ]
    },
    {
      path: '/login',
      name: '登陆',
      component: Login
    },
    {
      path: '/resetPassword',
      name: '重置密码',
      component: ResetPassword
    },
    {
      path: '/',
      name: '安盾线索',
      component: Main,
      children: [
        {
          path: '/clue/reviewedClue',
          name: '待审核',
          component: () => import('@/view/clue/reviewedClue.vue'),
          meta: {
            type: '菜单',
            name: 'PendingReview',
            nameCode: 'PendingReview'
          }
        },
        {
          path: '/clue/allClue',
          name: '全部',
          component: () => import('@/view/clue/allClue.vue'),
          meta: {
            type: '菜单',
            name: 'All',
            nameCode: 'All'
          }
        },
        {
          path: '/clue/leadPurchase',
          name: '线索测购',
          component: () => import('@/view/clue/leadPurchase.vue'),
          meta: {
            type: '菜单',
            name: 'CluesForTesting',
            nameCode: 'CluesForTesting'
          }
        }

      ]
    },

    {
      path: '/',
      name: '安盾线索',
      component: Main,
      children: [
        {
          path: '/channelClue/channelAllClue',
          name: '全部',
          component: () => import('@/view/clue/channelAllClue.vue'),
          meta: {
            type: '菜单',
            name: 'All',
            nameCode: 'All'
          }
        }

      ]
    },
    {
      path: '/',
      name: '供应商线索',
      component: Main,
      children: [
        {
          path: '/clue/custReviewedClue',
          name: '待审核' | 'PendingReview',
          component: () => import('@/view/clue/custReviewedClue.vue'),
          meta: {
            type: '菜单',
            name: 'PendingReview',
            nameCode: 'PendingReview'
          }
        },
        {
          path: '/clue/custAllClue',
          name: '全部',
          component: () => import('@/view/clue/custAllClue.vue'),
          meta: {
            type: '菜单',
            name: 'All',
            nameCode: 'All'
          }
        }
      ]
    },
    {
      path: '/',
      name: '情报管理',
      component: Main,
      children: [
        {
          path: '/gen/allGen',
          name: '全部情报',
          component: () => import('@/view/gen/allGen/index.vue'),
          meta: {
            type: '菜单',
            name: 'IntelligenceManage',
            nameCode: 'IntelligenceManage'
          }
        }
      ]
    },
    {
      path: '/',
      name: '项目',
      component: Main,
      children: [
        {
          path: '/project/projectList',
          name: '项目列表',
          component: () => import('@/view/project/projectList.vue'),
          meta: {
            type: '菜单',
            name: 'ProjectList',
            nameCode: 'ProjectList'
          }
        }
      ]
    },
    {
      path: '/',
      name: '安盾案件',
      component: Main,
      children: [
        {
          path: '/case/civilCase',
          name: '民事案件',
          component: () => import('@/view/case/civilCase.vue'),
          meta: {
            type: '菜单',
            name: 'CivilCase',
            nameCode: 'CivilCase'
          }
        },
        {
          path: '/case/administrativeCase',
          name: '行政案件',
          component: () => import('@/view/case/administrativeCase.vue'),
          meta: {
            type: '菜单',
            name: 'AdministrativeCase',
            nameCode: 'AdministrativeCase'

          }
        },
        {
          path: '/case/criminalCase',
          name: '刑事案件',
          component: () => import('@/view/case/criminalCase.vue'),
          meta: {
            type: '菜单',
            name: 'CriminalCase',
            nameCode: 'CriminalCase'
          }
        }
      ]
    },

    {
      path: '/',
      name: '安盾案件',
      component: Main,
      children: [
        {
          path: '/channelCase/channelCivilCase',
          name: '民事案件',
          component: () => import('@/view/case/channelCivilCase.vue'),
          meta: {
            type: '菜单',
            name: 'CivilCase',
            nameCode: 'CivilCase'
          }
        },
        {
          path: '/channelCase/channelAdministrativeCase',
          name: '行政案件',
          component: () => import('@/view/case/channelAdministrativeCase.vue'),
          meta: {
            type: '菜单',
            name: 'AdministrativeCase',
            nameCode: 'AdministrativeCase'

          }
        },
        {
          path: '/channelCase/channelCriminalCase',
          name: '刑事案件',
          component: () => import('@/view/case/channelCriminalCase.vue'),
          meta: {
            type: '菜单',
            name: 'CriminalCase',
            nameCode: 'CriminalCase'
          }
        }
      ]
    },
    {
      path: '/',
      name: '开票管理',
      component: Main,
      children: [
        {
          path: '/settlementCenter/invoicing/list/index',
          name: '开票列表',
          component: () =>
            import('@/view/invoicing/list/index.vue'),
          meta: {
            type: '菜单',
            name: 'InvoiceList',
            nameCode: 'InvoiceList'
          }
        }
      ]
    },
    {
      path: '/',
      name: '案件管理',
      component: Main,
      children: [
        {
          path: '/case/customerCase',
          name: '供应商案件',
          component: () => import('@/view/case/supplierCase.vue'),
          meta: {
            type: '菜单',
            name: 'VendorCase',
            nameCode: 'VendorCase'
          }
        }
      ]
    },
    // {
    //   path: '/',
    //   name: '权属查询',
    //   component: Main,
    //   children: [
    //     {
    //       path: '/tools/zhihuiya',
    //       name: '专利查询',
    //       component: () => import('@/view/tools/zhihuiya/index.vue'),
    //       meta: {
    //         type: '菜单',
    //         name: 'PatentSearch',
    //         nameCode: 'PatentSearch',
    //         parentMenu: 'tools:-'
    //       }
    //     }
    //   ]
    // },
    {
      path: '/',
      name: '侵权监测',
      component: Main,
      children: [
        {
          path: '/tools/oldOnlineMonitor',
          name: '线上监测（旧版）',
          component: () => import('@/view/tools/onlineMonitor/index.vue'),
          meta: {
            type: '菜单',
            name: 'oldOnlineMonitor',
            nameCode: 'oldOnlineMonitor'
          }
        },
        {
          path: '/tools/onlineMonitor',
          name: '线上监测',
          component: () => import('@/view/tools/newOnlineMonitor/index.vue'),
          meta: {
            type: '菜单',
            name: 'OnlineMonitor',
            parentMenu: 'tools:-'
          }
        },
        {
          path: '/tools/offlineMonitor',
          name: '线下监测',
          component: () => import('@/view/tools/offlineMonitor/index.vue'),
          meta: {
            type: '菜单',
            name: 'OfflineMonitor',
            nameCode: 'OfflineMonitor'
          }
        }
      ]
    },
    {
      path: '/',
      name: '供应商管理',
      component: Main,
      children: [
        {
          path: '/supplier/supplierManage',
          name: '供应商管理',
          component: () => import('@/view/supplier/index.vue'),
          meta: {
            type: '菜单',
            name: 'SupplierManage',
            nameCode: 'SupplierManage'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js